import React, { useState  } from 'react'
import { useSelector } from 'react-redux'
import Slider from '../slides/Slider'
import PlayerHeader from './PlayerHeader'

const BottomPlaylists = (props) => {

    const [sliderVisible, setSliderVisible] = useState(true)

    const { playlistVideos, loadingPlaylistVideos } = useSelector(state => state.userPlaylists)
    

    return (
        <>
            {   loadingPlaylistVideos ?     
            <div className = "text-info">
                loading...
            </div> :
            playlistVideos && playlistVideos.length > 0 &&
                <>
            {
                <PlayerHeader
                    searchParams = {props.searchParams}
                    setSearchParams = {props.setSearchParams}
                    setSliderVisible = {setSliderVisible}
                    sliderVisible = {sliderVisible}
                    menuVisible = {props.menuVisible}
                    playing = {props.playing}
                
                />
            } {
                sliderVisible && 
                <div className = 'w-100 position-relative bottom-0 overflow-hidden d-none d-md-flex justify-content-end align-items-end m-0'
                    style={ props.width > 990 ? {height:"11vw"} :{height:'150px'}} 
                >   
                    <div 
                        className={!props.playing || props.menuVisible ? 'w-100 py-2 visible position-absolute bottom-0' : 'w-100 py-2 position-absolute hidden mb-0'}
                        onClick={(e)=>{e.stopPropagation()}}
                        style={{backgroundColor:"#07294C80", zIndex:'150'}}
                        >
                        <Slider
                            num = {6}
                            type = {4}
                            showTitle = {true}
                            tvData={playlistVideos}
                            slideClickHandler={props.videoClickHandler}
                        />
                    </div>
            
                </div>
            }

                </>
            }  
        </>
    );
};

export default BottomPlaylists;